import { Component, HostListener } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../../../services/authentication.service'

@Component({
    selector: 'app-redefine-header',
    templateUrl: './redefine-header.component.html',
    styleUrls: ['./redefine-header.component.scss'],
})
export class RedefineHeaderComponent {
    profileMenuOpen = false

    constructor(
        private router: Router,
        public authService: AuthenticationService
    ) {}

    viewAllProperties(): void {
        // No query param needed - map page detects enterprise from domain
        this.router.navigate(['/map-search'])
    }

    goToAdmin(): void {
        this.router.navigate(['/admin'])
    }

    toggleProfileMenu(): void {
        this.profileMenuOpen = !this.profileMenuOpen
    }

    signOut(): void {
        this.profileMenuOpen = false
        this.authService.signOut()
        this.router.navigate(['/'])
    }

    // Close menu when clicking outside
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement
        if (!target.closest('.profile-dropdown')) {
            this.profileMenuOpen = false
        }
    }
}
